import { render, staticRenderFns } from "./couponReceiving.vue?vue&type=template&id=43d5fb5e"
import script from "./couponReceiving.vue?vue&type=script&lang=js"
export * from "./couponReceiving.vue?vue&type=script&lang=js"
import style0 from "./couponReceiving.vue?vue&type=style&index=0&id=43d5fb5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports